import React from 'react';
import UHCSidebarTitle, { UHCSidebarTitleProps } from '../../../Atoms/Sidebar/Title/Title';
import './Line.scss'

export interface UHCSidebarLineProps {
    title: UHCSidebarTitleProps['text'],
    lineContent: React.ReactNode
}

const UHCSidebarLine: React.FC<UHCSidebarLineProps> = (props: UHCSidebarLineProps) => {
    return (
        <div className="sidebar-line">
            <UHCSidebarTitle text={props.title} />
            <div className='linecontent-container'>{props.lineContent}</div>
        </div>
    )
}

export default UHCSidebarLine;